import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getIterableErrors',
    standalone: false
})
export class GetIterableErrorsPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        if (!value) {
            return value;
        }
        return Object.keys(value);
    }
}
